// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__23ZNV","fullscreen":"styles_fullscreen__1-YFf","open":"styles_open__gShnZ","containerScroll":"styles_containerScroll__2Jh1h"};